import { render, staticRenderFns } from "./goart-default.vue?vue&type=template&id=2d06dd64"
import script from "./goart-default.vue?vue&type=script&lang=js"
export * from "./goart-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoArtFullLoading: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/loading/GoArtFullLoading.vue').default,GoArtToastLoading: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtToastLoading.vue').default,GoArtDialogMsg: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtDialogMsg.vue').default,GoArtToast: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtToast.vue').default,GoArtConfirm: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/goart/mobile/GoArtConfirm.vue').default})
